<template>
  <full-page ref="fullpage" :options="fullpageOptions" id="fullpage">
    <div
      class="section"
      v-for="(item, index) in fullpageList"
      :key="item + index"
    >
      <custom-headers v-if="index === 0" :title="item.headerTitle" />
      <article-outline :page="index + 1" :title="item.outlineTitle" />
      <div
        class="backpage-container"
        @mouseenter="triggerBackpageAnimate(index)"
        @mouseleave="offBackpageAnimate(index)"
        @click="backpage"
      >
        <lottie
          :options="backpageDefaultOptions"
          @animCreated="anim => backpageHandleAnimation(anim, index)"
        />
      </div>
      <fullpageSection1 v-if="index === 0" />
      <fullpageSection2
        v-if="index === 1"
        :isfullpagetranslate="isfullpagetranslate"
      />
      <fullpageSection3 v-if="index === 2" />
      <div class="scrolltop-container" v-if="index !== 0" @click="scrollToTop">
        <lottie :options="scrollTopDefaultOptions" />
      </div>
    </div>
  </full-page>
</template>
<script>
import CustomHeaders from "../components/Header.vue";
import ArticleOutline from "../components/ArticleOutline.vue";
import FullpageSection1 from "../views/AboutMe/fullpage-section1";
import FullpageSection2 from "../views/AboutMe/fullpage-section2";
import FullpageSection3 from "../views/AboutMe/fullpage-section3";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Lottie from "vue-lottie";
import * as scrollTopJSON from "../assets/json/rocket.json";
import * as backArrowJSON from "../assets/json/back-arrow.json";

library.add(faGithub, faPhoneAlt, faEnvelope);

export default {
  name: "AboutMe",
  components: {
    "custom-headers": CustomHeaders,
    ArticleOutline,
    FullpageSection1,
    FullpageSection2,
    FullpageSection3,
    lottie: Lottie
  },
  data() {
    return {
      fullpageOptions: {
        afterLoad: this.afterLoad
      },
      fullpageList: [
        {
          headerTitle: "About Me",
          outlineTitle: "Who Am I"
        },
        {
          headerTitle: "",
          outlineTitle: "Skills"
        },
        {
          headerTitle: "",
          outlineTitle: "Experience"
        }
      ],
      isfullpagetranslate: false,
      scrollTopDefaultOptions: { animationData: scrollTopJSON.default },
      backpageDefaultOptions: { animationData: backArrowJSON.default },
      backpageAnim: []
    };
  },
  methods: {
    afterLoad(prev, now) {
      if (now.index !== 0) {
        this.isfullpagetranslate = true;
      }
    },
    backpageHandleAnimation(anim, pageIndex) {
      this.backpageAnim.push(anim);
      this.backpageAnim[pageIndex].stop();
    },
    triggerBackpageAnimate(pageIndex) {
      this.backpageAnim[pageIndex].play();
    },
    offBackpageAnimate(pageIndex) {
      this.backpageAnim[pageIndex].stop();
    },
    backpage() {
      this.$router.push("/");
    },
    scrollToTop() {
      this.$refs.fullpage.api.moveTo(1);
    }
  }
};
</script>
<style lang="scss">
#fullpage {
  .backpage-container {
    position: absolute;
    width: 100px;
    top: 3vw;
    left: 0;
    cursor: pointer;
    filter: brightness(1.3) saturate(100%) grayscale(1);
  }
  .main-content {
    .header-title {
      & > span {
        // font-size: 38px;
        font-size: 2.2vw;
        margin-right: 15px;
      }
      & > span:first-of-type {
        // font-size: 42px;
        font-size: 2.5vw;
        font-weight: bold;
      }
    }
    p {
      line-height: 1.5;
      // font-size: 24px;
      font-size: 1.3vw;
      margin-top: 25px;
      font-family: "Microsoft JhengHei";
    }
    .link-list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row-reverse;

      > li {
        width: 100%;
        border-radius: 50%;
        text-align: center;
        padding: 10px 0;
        font-size: 1rem;
        color: #cbcbcb;
        cursor: pointer;
        text-align: left;

        &:hover {
          color: #abaaaa;
        }
        > a {
          > span {
            margin-left: 10px;
          }
        }
      }
    }
  }
  .scrolltop-container {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(-7vw);

    svg {
      > g {
        cursor: pointer;
      }
    }
  }
}
</style>
